import { createTheme, ThemeProvider } from "@material-ui/core";
import "VideoPlace/AppVideoPlace.css";
import React from "react";
import TemplateVideoPlace from "template/TemplateVideoPlace";
import Home from "VideoPlace/pages/Home/Home";
import Produto from "VideoPlace/pages/Produto/Produto";
import VideoListing from "VideoPlace/pages/VideoListing/VideoListing";
import VideoListingAnunciantes from "VideoPlace/pages/VideoListing/VideoListingAnunciantes";
import VideoListingQuadro from "VideoPlace/pages/VideoListing/VideoListingQuadro";

export default function VideoPlaceApp() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#0a0a0a",
        contrastText: "#dbdbdb",
      },
      secondary: {
        main: "#dbdbdb",
        contrastText: "#0a0a0a",
      },
      background: {
        default: "#262626",
        paper: "#1a1a1a",
      },
    },
    overrides: {
      MuiButton: {
        text: {
          textDecoration: "bold",
        },
        contained: {
          fontSize: "1.5rem",
          color: "#ffffff",
          backgroundImage:
            "linear-gradient(90deg, #ffdd00, red, #ff00ea, blue, #00f7ff)",
          transition: "fade",
        },
        outlined: {
          borderColor: "#ff00ea",
          color: "#00f7ff",
        },
      },
    },
  });

  const routes = [
    {
      title: "Home",
      path: "/",
      visible: true,
      exact: true,
      component: Home,
    },
    {
      title: "Categoria",
      path: "/categoria/:categoria",
      visible: true,
      component: VideoListing,
    },
    {
      title: "Produto",
      path: "/produto/:produto",
      visible: true,
      component: Produto,
    },
    {
      title: "Anunciante",
      path: "/anunciante/:anunciante",
      visible: true,
      component: VideoListingAnunciantes,
    },
    {
      title: "Quadro",
      path: "/quadro/:quadro",
      visible: true,
      component: VideoListingQuadro,
    },
  ];
  return (
    <div>
      <ThemeProvider theme={theme}>
        <TemplateVideoPlace routes={routes} />
      </ThemeProvider>
    </div>
  );
}
